import { WidgetConfigurableMessagesConfig } from "@xapp/stentor-chat-widget";

export interface ConfigurableMessagesItems {
    retry: number;
    delay: number;
    text: string;
}

/**
 * Default configuration messages
 * @returns 
 */
export function getConfigurableMessages(): WidgetConfigurableMessagesConfig {
    return {
        items: [
            {
                delay: 5,
                //eslint-disable-next-line
                text: "We are having trouble communicating with the assistant right now. Re-trying in ${sec} seconds...",
            },
            {
                delay: 5,
                //eslint-disable-next-line
                text: "We are still having trouble communicating with the assistant right now. Re-trying in ${sec} seconds...",
            },
            {
                delay: 0,
                text: "Sorry, we cannot communicate with the assistant right now. Please check your connection or try again later.",
            },
        ],
    };
}

export function getConfigurableMessagesConfig(
    messages: WidgetConfigurableMessagesConfig
): ConfigurableMessagesItems[] {
    const { items } = messages;

    // First one is silent, keeps the same message
    const config: ConfigurableMessagesItems[] = [{ retry: 0, delay: 10, text: "" }];

    if (Array.isArray(items) && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
            config.push({ retry: i + 1, delay: items[i].delay, text: items[i].text })
        }
    }

    return config;
}
